module.exports = __webpack_public_path__ + "static/media/straighttrack.9d34a133.png";